<template>
  <div>
    <Row :gutter="20">
      <i-col :xs="12"
             :md="8"
             :lg="8"
             v-for="(infor, i) in inforCardData"
             :key="`infor-${i}`"
             style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow
                    :color="infor.color"
                    :icon="infor.icon"
                    :icon-size="36">
          <count-to :end="infor.count"
                    count-class="count-style" />
          <p>{{ infor.title }}</p>
        </infor-card>
      </i-col>
    </Row>
    <!-- <Row :gutter="20" style="margin-top: 10px;" v-if="is_admin()">
      <i-col :md="8" :lg="8">
        <p class="mqtt" count-class="count-style">实时上报</p>
      </i-col>
      <i-col :md="16" :lg="16">
        <count-to :end="mqtt_upload_count" class="mqtt_count" count-class="count-style"/>
      </i-col>
    </Row> -->
    <!-- <Row :gutter="20" style="margin-top: 10px;" v-if="is_admin()">
      <i-col :md="6" :lg="6">
        <p class="all2" count-class="count-style">电量</p>
      </i-col>
      <i-col :md="18" :lg="18">
        <count-to :end="item_total" class="all" count-class="count-style"/>
      </i-col>
    </Row> -->
    <Row :gutter="20"
         style="margin-top: 10px;">
      <i-col :md="24"
             :lg="8"
             style="margin-bottom: 20px;">
        <Card shadow>
          <chart-pie style="height: 300px;"
                     :value="pieData"
                     :text="$t('pages_single_page_home_home_1116')"></chart-pie>
        </Card>
      </i-col>
      <i-col :md="24"
             :lg="16"
             style="margin-bottom: 20px;">
        <Card shadow>
          <Tabs>
            <Tab-pane :label="$t('pages_single_page_home_home_1117')"
                      key="1">
              <chart-bar style="height: 248px;"
                         :value="weekly"
                         :text="$t('pages_single_page_home_home_1117')" />
            </Tab-pane>
            <Tab-pane :label="$t('pages_single_page_home_home_1118')"
                      key="2">
              <chart-bar type="daily"
                         style="height: 248px;"
                         :value="daily"
                         :text="$t('pages_single_page_home_home_1118')" />
            </Tab-pane>
          </Tabs>
        </Card>
      </i-col>
    </Row>
    <!-- <Row :gutter="20" style="margin-top: 10px;">
      <i-col style="margin-bottom: 20px;">
        <Card shadow>
          <chart-bar style="height: 300px;" :value="barData" text="每月收益"/>
        </Card>
      </i-col>
    </Row> -->
  </div>
</template>

<script>
import i18n from '../../../locales/index'

import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import config from '@/config'
import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  name: 'home',
  components: {
    InforCard,
    CountTo,
    ChartPie,
    ChartBar
  },
  data () {
    return {
      mqtt_upload_count: 0,
      websocket: null
    }
  },
  computed: {
    ...mapGetters('dashboard', [
      'inforCardData',
      'pieData',
      'item_total'
    ]),
    ...mapState('dashboard', [
      'weekly',
      'daily',
    ])
  },
  methods: {
    ...mapActions('dashboard', ['dashboardCount']),
    initWebSocket () {
      const wsUrl =
        process.env.NODE_ENV === 'development'
          ? config.wsUrl.dev
          : config.wsUrl.pro
      this.websocket = new WebSocket(wsUrl)
      this.websocket.onopen = this.websocketonopen
      this.websocket.onerror = this.websocketonerror
      this.websocket.onmessage = this.websocketonmessage
      this.websocket.onclose = this.websocketclose
    },
    websocketonopen () {
      console.log('WebSocket连接成功')

      const data = JSON.stringify({
        command: 'subscribe',
        identifier: JSON.stringify({ channel: 'MqttChannel' })
      })
      this.websocketsend(data)
    },
    websocketonerror (e) {
      console.log('WebSocket连接发生错误', e)
    },
    websocketonmessage (e) {
      if (JSON.parse(e.data).type !== 'ping') {
        const { message } = JSON.parse(e.data)
        if (message) {
          this.mqtt_upload_count = message.mqtt_upload_count
        }
      }
    },
    websocketsend (agentData) {
      this.websocket.send(agentData)
    },
    websocketclose () {
      console.log('connection closed')
    },
    is_admin () {
      const bool = this.$store.state.editor.me.role === i18n.t('libs_util_102')
      console.log(bool)
      return bool
    }
  },
  created () {
    if (this.is_admin()) {
      this.initWebSocket()
    }
  },
  mounted () {
    this.dashboardCount()
  },
  destroyed () {
    if (this.is_admin()) {
      this.websocketclose()
    }
  }
}
</script>

<style lang="less">
.count-style {
  font-size: 50px;
}
.all {
  font-size: 60px;
  text-align: center;
  background-color: black;
  color: red;
  letter-spacing: 5px;
}
.all2 {
  font-size: 60px;
  text-align: center;
  background-color: black;
  color: red;
  letter-spacing: 5px;
}
.mqtt {
  font-size: 60px;
  text-align: center;
  background-color: black;
  color: red;
  letter-spacing: 5px;
}
.mqtt_count {
  font-size: 60px;
  text-align: center;
  background-color: black;
  color: red;
  letter-spacing: 5px;
}
</style>
